module.exports = __webpack_public_path__ + "media/images/plaid-logo-282f9430020bfd4069dedd985cc0be2f.png";